export const outsourcedOptions = [
  {'text': 'No', 'value': 'N'},
  {'text': 'Si', 'value': 'S'},
];

export const responsibleOptions = [
  {'text': 'PUERTO', 'value': 'PUERTO'},
  {'text': 'NAVIERA', 'value': 'NAVIERA'},
  {'text': 'TRANSPORTE', 'value': 'TRANSPORTE'},
  {'text': 'ALMACENERA', 'value': 'ALMACENERA'},
  {'text': 'TDE', 'value': 'TDE'},
  {'text': 'FABRICANTE', 'value': 'FABRICANTE'},
];
